"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFdrCatalogOrderInput = void 0;
const filterOutEmptyValues = (obj) => {
    return (Object.entries(obj)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .filter(([_, value]) => value) // Filter out falsy values
        .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {}));
};
const getFdrCatalogOrderInput = (formValues, catalogIds) => {
    const { city, country: countryCode, road: street, zip, recaptchaToken, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    subscribe } = formValues, rest = __rest(formValues, ["city", "country", "road", "zip", "recaptchaToken", "subscribe"]);
    return {
        catalogIds,
        customer: Object.assign({ address: {
                city,
                countryCode,
                street,
                zip,
            } }, filterOutEmptyValues(rest)),
        recaptchaToken,
    };
};
exports.getFdrCatalogOrderInput = getFdrCatalogOrderInput;
//# sourceMappingURL=fdr-catalogs.utils.js.map